export default __webpack_public_path__ + "static/media/footer-esa-logo.e68f1aef.png";